module.exports = __webpack_public_path__ + "media/images/covid/icons/spray-d70a4c44ed8bc2f4dbca9891ffd0ce5f.png";